import {useLocation} from "react-router-dom";
import {useMemo} from "react";
import qs from "qs";
import getQuery from "@/utils/getQuery";

export default () => {
    const location = useLocation();
    return useMemo(() => getQuery(location.search), [location])
}
